import { createContext, useContext } from 'react'

export const RSSFeedContext = createContext(null)

export const useRSSFeedContext = () => {
  const context = useContext(RSSFeedContext)

  if (!context) {
    throw new Error('useRSSFeedContext must be used within RSSFeed component')
  }

  return context
}
